//@ts-nocheck

'use client'

import React from 'react'
import { usePagination } from 'react-instantsearch'

import * as S from './styles'
import Button from '../../../atoms/Button/Button.component'
import Icon from '../../../atoms/Icon/Icon.component'

function isModifierClick(event) {
  const isMiddleClick = event.button === 1

  return Boolean(
    isMiddleClick ||
    event.altKey ||
    event.ctrlKey ||
    event.metaKey ||
    event.shiftKey
  )
}

function PaginationItem({ isDisabled, href, onClick, ...props }) {
  const handleClick = (event) => {
    if (isModifierClick(event)) {
      return
    }

    event.preventDefault()

    onClick(event)
  }

  if (isDisabled) {
    return (
      <Button
        {...props}
        variant="algolia"
        disabled
      />
    )
    
  }

  return (
    <Button
      {...props}
      href={href}
      handleClick={handleClick}
      variant="algolia"
    />
  )
}

function AlgoliaPagination(props) {
  const {
    pages,
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    refine,
    createURL,
  } = usePagination(props)

  const firstPageIndex = 0
  const previousPageIndex = currentRefinement - 1
  const nextPageIndex = currentRefinement + 1
  const lastPageIndex = nbPages - 1

  // const getPaginationNumbers = (pageCount, page) => {
  //   const numbers = []
  //   for (let i = 1; i <= pageCount; i++) {
  //     if (i === 1 || i === pageCount || (i >= page - 1 && i <= page + 1)) {
  //       numbers.push(i)
  //     } else if (i === page || i === pageCount - 2) {
  //       numbers.push('...')
  //     }
  //   }
  //   return numbers
  // }

  /**
   * Builds an array of the specified length. The items are initialized using the
   * provided initializer function or with their index plus one, if none is provided.
   * @param {number} length length of the array to build
   * @param {function} initFunc function which is called for each element of the array
   * to initialize them. It is passed to the array's map function
   * @returns The built array
   */
  const pagesRange = (length, initFunc = undefined) => {
    return new Array(length)
      .fill(0)
      .map(initFunc ?? ((_, idx) => idx + 1))
  }

  const buildPagesToShow = (currentPage, totalPages, siblingCount) => {
    const normalizedCurrentPage = Math.max(0, Math.min(currentPage, totalPages - 1))
    const normalizedSiblingCount = Math.max(0, siblingCount)
    const normalizedTotalPages = Math.max(0, totalPages)
    const pagesArray = pagesRange(normalizedTotalPages)

    // aray which contains all the page numbers which should be shown
    // and the string 'dots' for EACH items which should be hidden
    const dottedPagination = pagesArray.map((value, idx) => {
      // always return the first and last page
      if (idx === 0 || idx === pagesArray.length - 1) {
        return value
      }
      
      // return the current page if it is at most at `siblingCount` items
      // of distance from the currentPage
      if (idx >= normalizedCurrentPage - normalizedSiblingCount
        && idx <= normalizedCurrentPage + normalizedSiblingCount) {
        return value
      }
      
      // return the string dots in all other cases
      return 'dots'
    })

    // remove multiple subsequent 'dots' strings
    const finalPagination = dottedPagination.reduce((prev, current) => {
      // do not add the current element to the result array when it
      // is the string 'dots' and the last element in the array
      // is the same string
      if (current === 'dots' && prev[prev.length - 1] === 'dots') {
        return prev
      }
      
      // otherwise concatenate the current element to the previous array
      // and return the resul
      return [...prev, current]
    }, [])

    return finalPagination
  }

  const pagesToShow = buildPagesToShow(currentRefinement, nbPages, 1)

  return nbPages > 1 ? (
    <S.AlgoliaPagination>
      <S.AlgoliaPaginationItem
        as={PaginationItem}
        isDisabled={isFirstPage}
        href={createURL(previousPageIndex)}
        onClick={() => refine(previousPageIndex)}
      >
        <Icon name="arrow-left" />
      </S.AlgoliaPaginationItem>
      {pagesToShow.map((paginationItem, i) => {
        if (paginationItem === 'dots') {
          return (
            <S.AlgoliaPaginationItem key={`Pagination-dots`} tabIndex="-1">
              ...
            </S.AlgoliaPaginationItem>
          )
        }

        const label = paginationItem

        return (
          <S.AlgoliaPaginationItem
            as={PaginationItem}
            key={paginationItem - 1}
            isDisabled={false}
            label={`${label}`}
            ariaLabel={`Pagina ${label}`}
            href={createURL(paginationItem - 1)}
            aria-current={currentRefinement === paginationItem - 1}
            onClick={() => refine(paginationItem - 1)}
            selected={i === paginationItem - 1}
          />
        )
      })}
      <S.AlgoliaPaginationItem
        as={PaginationItem}
        isDisabled={isLastPage}
        href={createURL(nextPageIndex)}
        onClick={() => refine(nextPageIndex)}
      >
        <Icon name="arrow-right" />
      </S.AlgoliaPaginationItem>
    </S.AlgoliaPagination>
  ) : null
}

export default AlgoliaPagination
